import { c as _c } from "react/compiler-runtime";
import { useMemo, type Dispatch, type ReactNode } from 'react';
import type { AxisType, ChartCardStateAction, ChartChoice } from '../internalTypes';
import type { ChartCardTFunction, ChartDataRow, ChartSelections } from '../types';
import { generateChartChoiceElements } from '../utils/input';
interface UseChoicesElementsResult {
  singleElements: ReactNode;
  multipleElements: ReactNode;
  togetherElements: Map<AxisType, ReactNode[]>;
}
const useChartChoicesElements = props => {
  const $ = _c(9);
  const {
    useChips,
    choicesList,
    choicesMap,
    transposedMetricsLists,
    selections,
    dispatch,
    t
  } = props;
  const choicesTogether = props.choicesTogether ?? false;
  let t0;
  if ($[0] !== choicesList || $[1] !== choicesMap || $[2] !== choicesTogether || $[3] !== dispatch || $[4] !== selections || $[5] !== t || $[6] !== transposedMetricsLists || $[7] !== useChips) {
    const singleElements = [];
    const multipleElements = [];
    const togetherElements = new Map();
    const generatedChoices = new Set();
    for (const choiceId of choicesList) {
      generateChartChoiceElements({
        useChips,
        singleElements,
        multipleElements,
        togetherElements,
        generatedChoices,
        choicesTogether,
        choiceId,
        choicesMap,
        transposedMetricsLists,
        selections,
        dispatch,
        t
      });
    }
    t0 = {
      singleElements,
      multipleElements,
      togetherElements
    };
    $[0] = choicesList;
    $[1] = choicesMap;
    $[2] = choicesTogether;
    $[3] = dispatch;
    $[4] = selections;
    $[5] = t;
    $[6] = transposedMetricsLists;
    $[7] = useChips;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  return t0;
};
export default useChartChoicesElements;